import React from "react";
import {Link} from "react-router-dom";
import {Col, Container, Row} from "reactstrap";
import { NavLink } from "react-router-dom"; 
// Import Images
import logolight from "../assets/RealEnglishImages/REALLogoTR.png";

const Footer = () => {
  
      const handleNavigation = (id) => {
          setTimeout(() => {
              const section = document.getElementById(id);
              if (section) {
                  section.scrollIntoView({ behavior: "smooth", block: "start" });
              }
          }, 100);
      };
  return (
    <React.Fragment>
      <footer
        className="custom-footer py-2 position-relative"
        style={{backgroundColor: "#333232"}}
      >
        <Container>
          <Row className="justify-content-center text-start">
            <Col
              lg={4}
              className="mt-4 fs-13"
            >
              <div>
                <Col xs={"auto"}>
                  <img
                    src={logolight}
                    alt="logo light"
                    height="120"
                  />
                </Col>
                <Col
                  xs={12}
                  className="mt-4"
                >
                  <p>
                    For happy students who embrace the joy of learning and want
                    to return for more.
                  </p>
                  <p className="ff-secondary">
                    Your gateway to a Real-World grasp of English.
                  </p>
                </Col>
              </div>
            </Col>

            <Col
              lg={7}
              className="ms-lg-auto"
            >
              <Row className="justify-content-center text-start">
                <Col
                  xs={5}
                  className="mt-4"
                >
                  <h5 className="text-white mb-0">Company</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list">
                      <li>
                      <NavLink to="/AboutUs" className="nav-link" onClick={() => handleNavigation("AboutUs")}>About Us</NavLink>
                      </li>
                      <li>
                         <NavLink to="/OurTeachers" className="nav-link" onClick={() => handleNavigation("OurTeachers")}>Our Teachers</NavLink>
                      </li>
                      <li>
                        <NavLink to="/OurSchool" className="nav-link" onClick={() => handleNavigation("OurSchool")}>Our School</NavLink>
                      </li>
                      <li> <NavLink to="/Gallery" className="nav-link" onClick={() => handleNavigation("Gallery")}>Gallery</NavLink> </li>
                      <li>
                        <NavLink to="/BilingualProject" className="nav-link" onClick={() => handleNavigation("BilingualProject")}>The Bilingual Project</NavLink>
                      </li>
                      <li>
                     <NavLink to="/Reviews" className="nav-link" onClick={() => handleNavigation("Reviews")}>Reviews</NavLink>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col
                  xs={7}
                  className="mt-4"
                >
                  <h5 className="text-white mb-0">Contact</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list">
                      <li>
                        <Link style={{pointerEvents: "none", color: "inherit"}}>
                          Address: Averof 5, Édessa, Greece 58200
                        </Link>
                      </li>
                      <li>
                        <Link style={{pointerEvents: "none", color: "inherit"}}>
                          Phone: +030 238130 2089
                        </Link>
                      </li>
                      <li>
                        <Link style={{pointerEvents: "none", color: "inherit"}}>
                          E-mail: realenglished@gmail.com
                        </Link>
                      </li>
                      <li>
                        <Link style={{pointerEvents: "none", color: "inherit"}}>
                        Operating Hours: 11:00 AM - 9:00 PM
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
      

          <Row className="text-center text-sm-start align-items-center mt-0">
            <Col sm={4}>
          
              <div className="text-sm-start mt-3 mt-sm-0 ">  
                <ul className="list-inline mb-0 footer-social-link">
                  <li className="list-inline-item">
                  <a href="https://www.facebook.com/realeglishedessa" className="text-white me-3"><i className="mdi mdi-facebook fs-24"></i></a>
                    {/* <Link
                      to="https://www.facebook.com/realeglishedessa"
                      className="avatar-xs d-block text-white"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-facebook-fill"></i>
                      </div>
                    </Link> */}
                  </li>
                  <li className="list-inline-item">
                  <a href="https://www.instagram.com/real.englishacademy/" className="text-white me-3"><i className="mdi mdi-instagram fs-24"></i></a>
                    {/* <Link
                      to="https://www.instagram.com/real.englishacademy/"
                      className="avatar-xs d-block text-white"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-instagram-fill"></i>
                      </div>
                    </Link> */}
                  </li>
                  {/* <li className="list-inline-item">
                  <a href="#" className="text-white"><i className="mdi mdi-twitter fs-24"></i></a>
                    <Link
                      to="#"
                      className="avatar-xs d-block text-white"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-google-fill"></i>
                      </div>
                    </Link>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col
              sm={8}
              className=""
            >
              <div className="text-center text-sm-center text-md-end pt-2">
                <p className="copy-rights mb-0">
                  {new Date().getFullYear()} Real English Academy. All rights reserved.
                  <p>Designed by Vasilis Mylonas.</p>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
